import GoogleMapsLoader from 'google-maps';

import styles from './styles.json';

export default class BrixMap {
  static init(...parameters) {
    return new BrixMap(...parameters);
  }

  constructor(block) {
    this.block = block;
    this.tabletMode = false;

    // Check if state has changed otherwise do not change map options and position.
    this.isParentTablet = null;

    // Map center point has two states
    this.mapCenterPoint = null;
    // this.setupListeners();
    this.onReady();
  }

  setupListeners() {
    // console.log('setupListeners');
    // window.addEventListener('DOMContentLoaded', () => {
    //   console.log('DOMContentLoaded');
    //   this.onReady();
    // }, false);
    window.addEventListener('resize', () => this.onResize());
  }

  onReady() {
    this.mapContainer = this.block.querySelector('.map');
    this.initMap();
  }

  initMap() {
    GoogleMapsLoader.KEY = this.mapContainer.dataset.key;
    GoogleMapsLoader.load(google => this.mapLoaded(google));
  }

  mapLoaded(google) {
    this.google = google;
    const mapWrapper = this.mapContainer;
    const latF = parseFloat(this.mapContainer.dataset.lat);
    const lngF = parseFloat(this.mapContainer.dataset.lng);
    const zoomInt = parseInt(this.mapContainer.dataset.zoom, 10);
    // const pinColor = this.convertHex(this.container.dataset.pincolor, 1);
    // Avoid svg – will not show in IE 11. Use base64 encoded png.
    const markerIcon = {
      url: 'data:image/png;base64,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',
      scaledSize: new google.maps.Size(66, 66), // Scaled size of marker image
      anchor: new google.maps.Point(33, 33), // Centers acnhor point
    };

    const options = {
      zoom: zoomInt,
      center: { lat: latF, lng: lngF },
      mapTypeControl: false,
      scrollwheel: false,
      streetViewControl: false,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.ROADMAP,
        mapTypeIds: ['roadmap', 'terrain'],
      },
      styles,
    };
    this.map = new google.maps.Map(mapWrapper, options);

    this.marker = new google.maps.Marker({
      position: { lat: latF, lng: lngF },
      map: this.map,
      icon: markerIcon,
      optimized: false,
    });

    // this.onResize();
  }

  repositionMap() {
    const latF = parseFloat(this.mapContainer.dataset.lat);
    const lngF = parseFloat(this.mapContainer.dataset.lng);
    let options = {};
    if (this.map) {
      if (this.tabletMode) {
        this.mapCenterPoint = {
          lat: latF,
          lng: lngF,
        };
        options = {
          draggable: false,
          zoomControlOptions: {
            position: this.google.maps.ControlPosition.LEFT_TOP,
          },
        };
      } else {
        this.mapCenterPoint = {
          lat: latF,
          lng: lngF,
        };
        options = {
          draggable: true,
          zoomControlOptions: {
            position: this.google.maps.ControlPosition.RIGHT_BOTTOM,
          },
        };
      }
      this.map.setOptions(options);
    }
  }

  onResize() {
    if (window.innerWidth > 1208) {
      this.tabletMode = false;
    } else {
      this.tabletMode = true;
    }

    if (this.isParentTablet) {
      if (this.isParentTablet !== this.tabletMode) {
        this.repositionMap();
      }
    } else {
      this.repositionMap();
    }

    this.map.setCenter(this.mapCenterPoint);
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-map', BrixMap.init);
}
